import { updateItemInCollection } from "directus/src/operations";

// Add createClient function
export async function updateClient({ item, clientId }) {
  try {
    const data = await updateItemInCollection("clients", clientId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
